import React, { useEffect, useState } from 'react';
import useCustomQuery from '@Utils/useCustomQuery';
import PropTypes from 'prop-types';
import { countStautus } from '@Apis/admin/transaction';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { TRADE_STATUS } from '../constants';
import { StatusWrapper } from './StatusStyles';

function Status({ activeTab, handleChangeStatus, filter, isRefreshStatus }) {
  const toggle = (tab) => {
    if (activeTab !== tab) {
      handleChangeStatus(tab);
    }
  };
  const { data, refetch } = useCustomQuery(countStautus, filter, false, null, 5000);
  const [statusCount, setStatusCount] = useState([]);

  useEffect(() => {
    if (isRefreshStatus) {
      refetch();
    }
  }, [isRefreshStatus]);

  useEffect(() => {
    if (data) {
      const itemsValue = Object.values(data);
      const countTotalStatus = itemsValue.reduce((prev, curr) => {
        let total;
        if (curr.status !== 'draft') {
          total = prev + curr.count;
        }
        return total;
      }, 0);
      const mapStatus = TRADE_STATUS.map((status) => {
        if (status.value === '') {
          status.count = countTotalStatus;
          return status;
        }
        const find = itemsValue.find((item) => item.status === status.value);
        if (find) {
          status.count = find.count;
        } else {
          status.count = 0;
        }
        return status;
      });
      setStatusCount([...mapStatus]);
    }
  }, [data]);

  return (
    <StatusWrapper>
      <Nav tabs className="mb-0">
        {statusCount.map((item) => {
          return (
            <NavItem key={item.label} className="">
              <NavLink
                active={activeTab === item.value}
                onClick={() => {
                  toggle(item.value);
                }}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <span
                    style={{ color: item.color }}
                    className="align-middle font-weight-bolder pl-50"
                  >
                    {item.label}
                  </span>
                  <div style={{ background: item.color }} className="count-status">
                    <span>{item.count}</span>
                  </div>
                </div>
              </NavLink>
            </NavItem>
          );
        })}
      </Nav>
    </StatusWrapper>
  );
}

Status.propTypes = {
  activeTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleChangeStatus: PropTypes.func,
  filter: PropTypes.any,
  isRefreshStatus: PropTypes.any,
};

export default Status;
